export const downLoadBlob = (blobFile: Blob, downLoadAs: string) => {
    const url = window.URL.createObjectURL(blobFile);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', downLoadAs);
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
}